import Spinner from 'react-bootstrap/Spinner'
import {useDispatch,useSelector} from 'react-redux'
import {useState} from 'react'
import {
	createChatResourceReference,
	setReferenceCreator
} from '../MessageCenter/messageCenterSlice'
import useCurrentUser from '../../hooks/useCurrentUser'

const DiscussResourceButton = ({children,style,user_id_number,name,type,id,className,pendingText="Linking to chat"})=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const trainer_chat_room = useSelector(state=>{
		const trainerRooms = state.messageCenter.rooms?.typeMap?.trainer
		return (
			Boolean(trainerRooms)
			? trainerRooms[0]
			: 0
		)
	})
	const dispatch = useDispatch()
	const [status,setStatus] = useState('idle')
	const handleClick = ()=>{
		//if a user_id_number is already specified then we can go directly to the linking
		//process. Otherwise we need to show the user a modal where they can select a client
		if(Boolean(user_id_number)||isClient){
			setStatus('pending')
			const payload = {
				resource_type:type,
				resource_id:id,
			}
			if(isClient){
				payload.room_id = trainer_chat_room
			}else{
				payload.user_id_number = user_id_number
			}
			dispatch(createChatResourceReference(payload))
			.then(()=>{
				setStatus('idle')
			})
		}else{
			dispatch(setReferenceCreator({
				resource:{type,id,name},
				show:true
			}))
		}
	}
	return (
		<button style={style} disabled={status==='pending'} onClick={handleClick} className={className}>
			{status==='pending'?<span>{pendingText}</span>:<span>{children}</span>||<span>Discuss this in the chat</span>} 
			{status==='pending'&&<Spinner className="ml-1" animation="border" size="sm"/>}
		</button>
	)
}

export default DiscussResourceButton